"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inventoryDetailStore = void 0;
const api_1 = require("client/api");
const ui_1 = require("client/components/ui");
const mobx_1 = require("mobx");
const ramda_1 = require("ramda");
class InventoryDetailStore {
    constructor() {
        this.inventory = {};
        this.icd10sList = [];
        this.icd10sListHasChanged = false;
        this.shouldHideViewIndication = false;
        //E-086
        this.isActionLogs = false;
        this.actionsLogs = [];
        /*
          When the inventory is submitted we want to pass the numeric value from the
          barcode to this function. This function will then convert the number to either
          an image or a base 64 string depending on what pdfMake requires.
        */
        // first lets look at Matts algorithim to see if we can make this code happen there.
        //  @action
        // convertBarcodeToImage() {
        // }
        this.findICD10 = async (search) => {
            this.icd10s = { loading: true };
            const result = await api_1.ICD10Endpoint.find.apiCall({
                query: { search }
            });
            if (api_1.isError(result)) {
                return result.code;
            }
            else {
                return result.icd10;
            }
        };
        this.loadICD10s = async (search) => {
            this.icd10s = { loading: true };
            const result = await api_1.ICD10Endpoint.list.apiCall({
                query: { start: 0, count: 0, search }
            });
            if (api_1.isError(result)) {
                this.icd10s = { error: result.code };
            }
            else {
                this.icd10s = { value: result.icd10s };
            }
        };
        this.addIcd10ToList = (icd10) => {
            // tkay added: condition to dismiss duplicate.
            if (!this.icd10sList.some(item => item.id === icd10.id)) {
                this.icd10sList.push(icd10);
                this.icd10sListHasChanged = true; // #TK added
            }
        };
        this.removeIcd10FromList = (index) => {
            this.icd10sListHasChanged = true; // #TK added
            this.icd10sList.splice(index, 1);
        };
        this.refreshState = () => {
            this.icd10sList = [];
        };
        this.readInventory = async (id, siteId) => {
            this.inventory = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.inventory.value
            };
            const result = await api_1.InventoryEndpoint.read.apiCall({
                query: { siteId },
                params: { id }
            });
            console.log(result);
            if (api_1.isError(result)) {
                alert("error in read inventory");
                this.inventory = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value
                };
            }
            else {
                const { inventoryCodes } = result.inventory;
                delete result.inventory.inventoryCodes;
                this.inventory = { status: ui_1.FormStatus.Clean, value: result.inventory };
                if (inventoryCodes && inventoryCodes.length) {
                    this.refreshState();
                    inventoryCodes.forEach(icd10s => {
                        this.addIcd10ToList(icd10s);
                        this.icd10sListHasChanged = false; // #TK added: set to false to set default to false.
                    });
                }
            }
        };
        this.saveInventory = async (inventory, cached) => {
            this.inventory = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.inventory.value
            };
            // console.log("inventory in store is ", inventory);
            const result = await api_1.InventoryEndpoint.save.apiCall(null, {
                inventory
            });
            console.log("result is ", result);
            if (api_1.isError(result)) {
                alert("error in save inventory, result is ");
                this.inventory = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value
                };
                // console.log("this.inventory in error is ", this.inventory);
            }
            else {
                //   if (!cached) {
                //     this.inventory = {
                //       status: FormStatus.Saved,
                //       value: merge(inventory, result.inventory)
                //     };
                //   } else {
                //     if (this.inventory.value.id === inventory.id) {
                //       this.inventory = {
                //         status: FormStatus.Saved,
                //         // value: merge(inventory, cached),
                //         value: merge(inventory, result.inventory)
                //       };
                //     }
                //   }
                // }
                this.inventory = {
                    status: ui_1.FormStatus.Saved,
                    // value: merge(inventory, cached),
                    value: ramda_1.merge(inventory, result.inventory)
                };
            }
        };
        //E-086
        this.readactionlog = async (id) => {
            const result = await api_1.InventoryEndpoint.readActionlog.apiCall({
                params: { id }
            });
            if (result) {
                return result;
            }
        };
        this.deleteInventory = async (inventory) => {
            const result = await api_1.InventoryEndpoint.remove.apiCall({
                params: { id: inventory.id }
            });
            if (api_1.isError(result)) {
                this.inventory = {
                    error: result.code,
                    unresolved: result === null || result === void 0 ? void 0 : result.unresolvedOrders,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value
                };
                return false;
            }
            else {
                return true;
            }
        };
        // C-046.10
        this.readClaimUnresolvedInventory = async (inventory) => {
            const result = await api_1.InventoryEndpoint.getClaimUnresolved.apiCall({
                params: { id: inventory.id },
            });
            if (api_1.isError(result)) {
                this.inventory = {
                    error: result.code,
                    unresolved: result === null || result === void 0 ? void 0 : result.unresolvedOrders,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value,
                };
                return false;
            }
            else {
                return true;
            }
        };
        // C-046.11
        this.enableInventory = async (inventory) => {
            const result = await api_1.InventoryEndpoint.enable.apiCall({
                params: { id: inventory.id }
            });
            if (api_1.isError(result)) {
                this.inventory = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value
                };
                return false;
            }
            else {
                return true;
            }
        };
        this.updateInventorySite = async (inventory, inventorySite) => {
            const result = await api_1.InventoryEndpoint.updatesite.apiCall(null, {
                inventory,
                inventorysite: inventorySite
            });
            if (api_1.isError(result)) {
                this.inventory = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value
                };
            }
            else {
                this.inventory = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(inventory, result.inventory)
                };
            }
        };
        // Active Formulary > Does not save update after select all  then deselect all C-046.182
        this.updateInventoryAllSite = async (inventory, inventorySite, checkedSelection = "single", isCheckedAll) => {
            const result = await api_1.InventoryEndpoint.updateAllsite.apiCall(null, {
                inventory,
                inventorysite: inventorySite,
                checkedSelection: checkedSelection,
                isCheckedAll: isCheckedAll
            });
            if (api_1.isError(result)) {
                this.inventory = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value,
                };
            }
            else {
                this.inventory = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(inventory, result.inventory),
                };
            }
        };
        this.saveInventorySites = async (inventory, inventorySites) => {
            this.inventory = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.inventory.value
            };
            const result = await api_1.InventoryEndpoint.savesites.apiCall(null, {
                inventory,
                inventorysites: inventorySites
            });
            if (api_1.isError(result)) {
                this.inventory = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value
                };
            }
            else {
                this.inventory = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(inventory, result.inventory)
                };
            }
        };
        this.saveInventorySite = async (inventory, inventorySite) => {
            this.inventory = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.inventory.value
            };
            const result = await api_1.InventoryEndpoint.saveinventorysite.apiCall(null, {
                inventory,
                inventorysite: inventorySite
            });
            if (api_1.isError(result)) {
                this.inventory = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value
                };
            }
            else {
                this.inventory = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(inventory, result.inventory)
                };
            }
        };
        this.saveSitePriorities = async (inventorySite) => {
            this.inventory = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.inventory.value
            };
            const result = await api_1.InventoryEndpoint.savesitepriorities.apiCall(null, {
                inventorysite: inventorySite
            });
            if (api_1.isError(result)) {
                console.error("Error in saveSitePriorities result is ", result);
                this.inventory = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.inventory.value
                };
            }
            else {
                // this.inventory = {
                //   status: FormStatus.Saved,
                //   value: merge(inventory, result.inventory),
                // };
            }
        };
        this.getSetIdFromPkg = async (pkg) => {
            const query = {
                pkg
            };
            const result = await api_1.InventoryEndpoint.getsetidfrompkg.apiCall({ query });
            if (api_1.isError(result)) {
                return "";
            }
            return result.splNdc ? result.splNdc.setId || result.splNdc.setid : "";
        };
        // E-086
        this.setActionLogs = (status, actionLogData) => {
            this.isActionLogs = status;
            this.actionsLogs = actionLogData;
        };
    }
    get name() {
        return (exports.inventoryDetailStore.inventory.value &&
            (exports.inventoryDetailStore.inventory.value.name ||
                exports.inventoryDetailStore.inventory.value.generic));
    }
    get icd10List() {
        return this.icd10sList;
    }
    get icd10ListChanged() {
        return this.icd10sListHasChanged;
    }
    setICD10sChangedToFalse() {
        this.icd10sListHasChanged = false;
    }
}
__decorate([
    mobx_1.observable
], InventoryDetailStore.prototype, "inventory", void 0);
__decorate([
    mobx_1.observable
], InventoryDetailStore.prototype, "icd10s", void 0);
__decorate([
    mobx_1.observable
], InventoryDetailStore.prototype, "icd10sList", void 0);
__decorate([
    mobx_1.observable
], InventoryDetailStore.prototype, "icd10sListHasChanged", void 0);
__decorate([
    mobx_1.observable
], InventoryDetailStore.prototype, "currentInventoryId", void 0);
__decorate([
    mobx_1.observable
], InventoryDetailStore.prototype, "shouldHideViewIndication", void 0);
__decorate([
    mobx_1.observable
], InventoryDetailStore.prototype, "isActionLogs", void 0);
__decorate([
    mobx_1.observable
], InventoryDetailStore.prototype, "actionsLogs", void 0);
__decorate([
    mobx_1.computed
], InventoryDetailStore.prototype, "name", null);
__decorate([
    mobx_1.computed
], InventoryDetailStore.prototype, "icd10List", null);
__decorate([
    mobx_1.computed
], InventoryDetailStore.prototype, "icd10ListChanged", null);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "setICD10sChangedToFalse", null);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "findICD10", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "loadICD10s", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "addIcd10ToList", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "removeIcd10FromList", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "refreshState", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "readInventory", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "saveInventory", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "readactionlog", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "deleteInventory", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "readClaimUnresolvedInventory", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "enableInventory", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "updateInventorySite", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "updateInventoryAllSite", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "saveInventorySites", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "saveInventorySite", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "saveSitePriorities", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "getSetIdFromPkg", void 0);
__decorate([
    mobx_1.action
], InventoryDetailStore.prototype, "setActionLogs", void 0);
exports.inventoryDetailStore = new InventoryDetailStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/store.ts
// module id = 265
// module chunks = 0 1